<div class="job-posts placements agreements  margin-top-30px">
  <div class="card skillassest-form">

  </div>
  <div class="card-body padding-top padding-left-0px padding-right-10px">
    <div class="row bk-color-sky">
      <div class="col-2"></div>
      <div class="col-12 border-right-left-clr text-align-left padding-right-5px my-profile-form padding-left-3px">
        <div class="row">
          <label class="col-3 margin-bottom-0px font-size-12px color-Assign">Welcome</label>
          <label class="col-6 padding-left-0px margin-bottom-0px font-size-12px font-weight-bold color-green">
            {{SelectedPatient.DisplayName}}
          </label>

        </div>

      </div>

    </div>
    <div class="row margin-top-5px" *ngIf="SelectedPatient">

      <div class="col-6">
        <label class="margin-bottom-0px font-size-16px">Profile</label>
      </div>
      <div class="col-6 float-right">
        <button type="submit"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
          View
        </button>
        <button type="submit"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px"
                (click)="EditDetails()">
          <i class="fas fa-pencil-alt nav-link-hand font-size-12px margin-top-5px"></i> Edit
        </button>
      </div>


    </div>

    <div class="row margin-top-5px">

      <div class="col-6">
        <label class="margin-bottom-0px font-size-16px">Medical History</label>
      </div>
      <div class="col-6 float-right">
        <button type="submit"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
          View
        </button>
        <button type="submit"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
          <i class="fas fa-pencil-alt nav-link-hand font-size-12px margin-top-5px"></i> Edit
        </button>
      </div>


    </div>

    <div class="row margin-top-5px">

      <div class="col-6">
        <label class="margin-bottom-0px font-size-16px">Clinical Examination</label>
      </div>
      <div class="col-6 float-right">
        <button type="submit"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
          View
        </button>
        <button type="submit"
                class="btn btn-profile actions-btn-prime-profile2 font-size-13px margin-right-15px">
          <i class="fas fa-pencil-alt nav-link-hand font-size-12px margin-top-5px"></i> Edit
        </button>
      </div>


    </div>
  </div>


</div>
 



